import { css } from 'emotion';

export namespace styles {
  export const container = css({
    cursor: 'pointer',
    background: 'none',
    borderStyle: 'none',
    padding: '0',
    font: 'inherit',
    outline: 'inherit'
  });
}
